import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { environment } from "../../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class B2cService {
  urlBase    = environment.urlApiB2c;
  urlBaseApi = environment.urlApi
  constructor(private http: HttpClient) { }
  login(credentials)
  {
    return this.http.post<any>(this.urlBase+"/index.php?action=loginUser",credentials);
  }
  addUser(credentials)
  {
    return this.http.post<any>(this.urlBase+"/index.php?action=addUser",credentials);
  }

  changePassword(credentials)
  {
    return this.http.post<any>(this.urlBase+"/index.php?action=changePasswordUser",credentials);
  }
  
  sendMail(data=null)
  {
    return this.http.post(this.urlBaseApi+"/sendmail",data);
  }

  isLoggedIn(){
    var typeCompte = localStorage.getItem('typeCompte');
    if(typeCompte === 'B2C' && typeCompte){
      return true
    }
    return false
  }

  addCommand(data:any)
  {
    return this.http.post(this.urlBase+"/?action=addCommand",data);
  }
  getCommandsUser(userId:any)
  {
    return this.http.get(this.urlBase+"/?action=getCommands&userId="+userId);
  }

  getCommand(commandId:any)
  {
    return this.http.get(this.urlBase+"/?action=getCommand&commandId="+commandId)
  }

  confirmeCart(data=null)
  {
    return this.http.post(this.urlBaseApi+"/confirmOrderbtoc",data);
  }
}
